skrilla.directive('entityNotes', function () {
    return {
        templateUrl: 'directives/entityNotes/entityNotes.html',
        scope: {
            entityType: "=",
            entityId: "=",
            pageKey: "="
        },
        controller: function ($scope, searchService, paginationService, queryService, srefService, cacheService, entityNoteService, modalService) {
            $scope.notes = [];
            entityNoteService.getNoteCategories().then(function (categories) {
                $scope.categories = categories;
                $scope.reset();
            });
            $scope.entityTitle = entityNoteService.formatEntityTitle($scope.entityType)

            $scope.reset = function () {
                $scope.query = {
                    pinnedOnly: false,
                    category: $scope.categories,
                    limit: 20
                }
            }

            let getNotes = function () {
                return searchService.get(`entityNotes/${$scope.entityId}` + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.notes = response.data.result;
                    $scope.notes.forEach((note) =>{
                        note.html = marked(note.content, {
                            gfm: true,
                            breaks: true
                        })
                    })
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.createNote = function () {
                cacheService.registerObject("entity", {
                    type: $scope.entityType,
                    id: $scope.entityId
                })
                modalService.openModal("views/createEntityNotesModal/createEntityNotesModal.html", true, 'lg', true, true, function () {
                    $scope.search();
                });
            }

            $scope.editNote = function (note) {
                cacheService.registerObject("note", {
                    id: note.id,
                    content: note.content,
                    status: note.pinned === true ? 'PINNED': "ACTIVE"
                })
                modalService.openModal("views/editEntityNotesModal/editEntityNotesModal.html", true, 'lg', true, true, function () {
                    $scope.search();
                });
            }

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getNotes, $scope.pageKey);
            }
            $scope.search();

            cacheService.registerObject("updateEntityNotesFn", $scope.search);

            $scope.pin = function (note) {
                searchService.put(`entityNotes/${note.id}/togglePin`).then(function () {
                    $scope.search();
                });
            }

            $scope.promoteToMaster = function (note) {
                modalService.confirm(`Are you sure you'd like to set this note as the master note?`, function () {
                    searchService.put(`entityNotes/${$scope.entityId}/${note.id}/promote`).then(function () {
                        $scope.search();
                    });
                });
            }

            $scope.delete = function (note) {
                modalService.confirm("Are you sure you'd like to delete this note?", function () {
                    searchService.deleteRequest(`entityNotes/${note.id}`).then(function () {
                        $scope.search();
                    });
                });
            }

        }
    };
});
